import { createFileRoute, Outlet } from '@tanstack/react-router'
import { SiteFooter } from './-components/site-footer'
import { SiteHeader } from './-components/site-header'
import './-styles/site.css'

export const Route = createFileRoute('/(public)')({
	ssr: true,
	component: PublicLayout
})

function PublicLayout() {
	const { appLanguage } = Route.useRouteContext()

	return (
		<div className='site'>
			<SiteHeader appLanguage={appLanguage} />
			<Outlet />
			<SiteFooter appLanguage={appLanguage} />
		</div>
	)
}
